import AppRoute from "models/AppRoute"
import { Guid } from "@/types"

interface IValuationRouteParams {
    valuationParameterId: Guid
}

const ValuationRoute = new AppRoute<IValuationRouteParams>({
    route: "/valuation/:valuationParameterId",
    navbar: true,
    authRequired: true,
})

export default ValuationRoute
